<template id="filtres">

        <div class="form-group filtres-condamnation facet-wrap">
    		  <label for="filtre_par_region">Région</label>
    		  <select id="filtre_par_region" class="form-control form-control-sm" v-model="region" @change="onChangeRegion()">
            <option value="">Toutes</option>
		        <option value="Abitibi-Témiscamingue">Abitibi-Témiscamingue</option>
		        <option value="Bas-Saint-Laurent">Bas-Saint-Laurent</option>
		        <option value="Capitale-Nationale">Capitale-Nationale</option>
		        <option value="Centre-du-Québec">Centre-du-Québec</option>
		        <option value="Chaudière-Appalaches">Chaudière-Appalaches</option>
		        <option value="Côte-Nord">Côte-Nord</option>
		        <option value="Estrie">Estrie</option>
		        <option value="Gaspésie-Îles-de-la-Madeleine">Gaspésie-Îles-de-la-Madeleine</option>
		        <option value="Lanaudière">Lanaudière</option>
		        <option value="Laurentides">Laurentides</option>
		        <option value="Laval">Laval</option>
		        <option value="Mauricie">Mauricie</option>
		        <option value="Montérégie">Montérégie</option>
		        <option value="Montréal">Montréal</option>
		        <option value="Nord-du-Québec">Nord-du-Québec</option>
		        <option value="Outaouais">Outaouais</option>
		        <option value="Saguenay-Lac-Saint-Jean">Saguenay-Lac-Saint-Jean</option>
    		  </select>
        </div>

        <div class="form-group filtres-condamnation facet-wrap">
          <label for="filtre_par_formation">Formation</label>
          <select id="filtre_par_formation" class="form-control form-control-sm" v-model="formation" @change="onChangeFormation()">
            <option value="">Toutes</option>
		        <option value="Gestionnaire d'établissement alimentaire (12 h)">Gestionnaire d'établissement alimentaire (12 h)</option>
		        <option value="Manipulateur d’aliments (6 h)">Manipulateur d’aliments (6 h)</option>
		        <option value="Organisme en contexte d’aide alimentaire (14 h)">Organisme en contexte d’aide alimentaire (14 h)</option>
		        <option value="Séance de formation (3 h 30)">Séance de formation (3 h 30)</option>
          </select>
        </div>

        <div class="form-group filtres-condamnation facet-wrap">
          <label for="filtre_par_langue">Langue</label>
          <select id="filtre_par_langue" class="form-control form-control-sm" v-model="langue" @change="onChangeLangue()">
            <option value="">Tous</option>
		        <option value="Anglais">Anglais</option>
		        <option value="Arabe">Arabe</option>
		        <option value="Chinois">Chinois</option>
		        <option value="Créole">Créole</option>
		        <option value="Espagnol">Espagnol</option>
		        <option value="Français">Français</option>
		        <option value="Laotien">Laotien</option>
		        <option value="Mandarin">Mandarin</option>
		        <option value="Thaïlandais">Thaïlandais</option>
          </select>
        </div>

        <div class="form-group filtres-condamnation facet-wrap">
          <label for="filtre_en_ligne">Formation offerte en ligne</label>
          <input type="checkbox" name="filtre_en_ligne" id="filtre_en_ligne" v-model="en_ligne" @change="onChangeEnLigne()">
        </div>
</template>

<script>
    export default{
        name:"FiltreCond",
        components: {
            
        },
        emits: ['filtreRegion','filtreFormation','filtreLangue','filtreEnLigne'],
        props: {
        },
        data(){
          return{
            region: '',
            formation: '',
            langue: '',
            en_ligne: ''
          }
        }, 
        methods:{
            onChangeRegion(){
              let region = this.region;
              this.$emit('filtreRegion',region);
            },
            onChangeFormation(){
              let formation = this.formation;
              this.$emit('filtreFormation',formation);
            },
            onChangeLangue(){
              let langue = this.langue;
              this.$emit('filtreLangue',langue);
            },
            onChangeEnLigne(){
              console.log("Changement pour offert en ligne : " + this.en_ligne);
              console.log(typeof this.en_ligne)
              let en_ligne_change = this.en_ligne;
              this.$emit('filtreEnLigne',en_ligne_change);
            }
        },
        computed: {
            
        },
        created() {
        }
    }
</script>